export default __webpack_public_path__ + "static/media/973.494a3595.png";